// extracted by mini-css-extract-plugin
module.exports = {"IAndCSecurityServices":"IAndCSecurityServices_IAndCSecurityServices__2ncoa"};